import { useTranslation } from 'react-i18next'

export const usePropertyOptions = () => {
  const { t } = useTranslation()

  const currencyOptions = [
    { value: 'UAH', label: 'UAH' },
    { value: 'USD', label: 'USD' },
    { value: 'EUR', label: 'EUR' },
  ]

  const cellingHeightOptions = [
    { label: t('cellingHeight.underTwoAndHalf'), value: 'underTwoAndHalf' },
    { label: t('cellingHeight.underThree'), value: 'underThree' },
    { label: t('cellingHeight.underFour'), value: 'underFour' },
    { label: t('cellingHeight.aboveFour'), value: 'aboveFour' },
  ]

  const yearOfConstructionOptions = [
    { label: `${t('step3.after')} 2020`, value: 'after2020' },
    { label: '2010-2020', value: '2010-2020' },
    { label: '2000-2010', value: '2000-2010' },
    { label: '1990-2000', value: '1990-2000' },
    { label: '1980-1990', value: '1980-1990' },
    { label: '1970-1980', value: '1970-1980' },
    { label: '1960-1970', value: '1960-1970' },
    { label: '1950-1960', value: '1950-1960' },
    { label: `${t('step3.before')} 1950`, value: 'before1950' },
  ]

  const furnitureOptions = [
    { label: t('furniture.refrigerator'), value: 'refrigerator' },
    { label: t('furniture.freezer'), value: 'freezer' },
    { label: t('furniture.stove'), value: 'stove' },
    { label: t('furniture.oven'), value: 'oven' },
    { label: t('furniture.microwave'), value: 'microwave' },
    { label: t('furniture.dishwasher'), value: 'dishwasher' },
    { label: t('furniture.electric_kettle'), value: 'electric_kettle' },
    { label: t('furniture.coffee_machine'), value: 'coffee_machine' },
    { label: t('furniture.washing_machine'), value: 'washing_machine' },
    { label: t('furniture.tv'), value: 'tv' },
    { label: t('furniture.air_conditioner'), value: 'air_conditioner' },
    { label: t('furniture.water_heater'), value: 'water_heater' },
    { label: t('furniture.wifi_router'), value: 'wifi_router' },
    { label: t('furniture.built_in_appliances'), value: 'built_in_appliances' },
    { label: t('furniture.bed'), value: 'bed' },
    { label: t('furniture.sofa'), value: 'sofa' },
    { label: t('furniture.armchairs'), value: 'armchairs' },
    { label: t('furniture.wardrobe'), value: 'wardrobe' },
    { label: t('furniture.dresser'), value: 'dresser' },
    { label: t('furniture.table'), value: 'table' },
    { label: t('furniture.chairs'), value: 'chairs' },
    { label: t('furniture.kitchen_set'), value: 'kitchen_set' },
    { label: t('furniture.safe'), value: 'safe' },
    { label: t('furniture.other'), value: 'other' },
  ]

  const parkingOptions = [
    { label: t('parking.closed_paid'), value: 'closed-paid' },
    { label: t('parking.closed_free'), value: 'closed-free' },
    { label: t('parking.ground_paid'), value: 'ground-paid' },
    { label: t('parking.ground_free'), value: 'ground-free' },
    { label: t('parking.underground_paid'), value: 'underground-paid' },
    { label: t('parking.underground_free'), value: 'underground-free' },
  ]

  const amenitiesOptions = [
    { label: t('amenities.balcony'), value: 'balcony' },
    { label: t('amenities.elevator'), value: 'elevator' },
    { label: t('amenities.internet'), value: 'internet' },
    { label: t('amenities.backup_power'), value: 'backup_power' },
    { label: t('amenities.soundproofing'), value: 'soundproofing' },
    { label: t('amenities.terrace_patio'), value: 'terrace_patio' },
  ]

  const transportOptions = [
    { label: t('transport.metro'), value: 'metro' },
    { label: t('transport.bus_stop'), value: 'bus_stop' },
    { label: t('transport.tram_stop'), value: 'tram_stop' },
    { label: t('transport.trolleybus_stop'), value: 'trolleybus_stop' },
    { label: t('transport.train_station'), value: 'train_station' },
    { label: t('transport.minibus'), value: 'minibus' },
    { label: t('transport.bike_lane'), value: 'bike_lane' },
  ]

  const infrastructureOptions = [
    { label: t('infrastructure.shops'), value: 'shops' },
    { label: t('infrastructure.schools'), value: 'schools' },
    { label: t('infrastructure.kindergartens'), value: 'kindergartens' },
    { label: t('infrastructure.playgrounds'), value: 'playgrounds' },
    { label: t('infrastructure.child_development_centers'), value: 'child_development_centers' },
    { label: t('infrastructure.clinics_hospitals'), value: 'clinics_hospitals' },
    { label: t('infrastructure.pharmacies_vet_clinics'), value: 'pharmacies_vet_clinics' },
    { label: t('infrastructure.banks_atms'), value: 'banks_atms' },
    { label: t('infrastructure.cafes_restaurants'), value: 'cafes_restaurants' },
    { label: t('infrastructure.sports_fitness_clubs'), value: 'sports_fitness_clubs' },
    { label: t('infrastructure.parks_recreation'), value: 'parks_recreation' },
    { label: t('infrastructure.car_washes_gas_stations'), value: 'car_washes_gas_stations' },
    { label: t('infrastructure.pickup_points'), value: 'pickup_points' },
  ]
  const windowViewOptions = [
    { label: t('windowView.city'), value: 'city' },
    { label: t('windowView.sea'), value: 'sea' },
    { label: t('windowView.park'), value: 'park' },
    { label: t('windowView.mountains'), value: 'mountains' },
    { label: t('windowView.courtyard'), value: 'courtyard' },
    { label: t('windowView.forest'), value: 'forest' },
    { label: t('windowView.lake_river'), value: 'lake_river' },
    { label: t('windowView.buildings'), value: 'buildings' },
    { label: t('windowView.road'), value: 'road' },
  ]
  const utilitiesOptions = [
    { label: t('utilities.electricity'), value: 'electricity' },
    { label: t('utilities.water_supply'), value: 'water_supply' },
    { label: t('utilities.sewage'), value: 'sewage' },
    { label: t('utilities.heating'), value: 'heating' },
    { label: t('utilities.gas_supply'), value: 'gas_supply' },
    { label: t('utilities.ventilation'), value: 'ventilation' },
  ]

  const minRentTermOptions = [
    { label: t('minRentTerm.1_month'), value: '1_month' },
    { label: t('minRentTerm.2_months'), value: '2_months' },
    { label: t('minRentTerm.3_months'), value: '3_months' },
    { label: t('minRentTerm.6_months'), value: '6_months' },
    { label: t('minRentTerm.1_year'), value: '1_year' },
    { label: t('minRentTerm.2_plus_years'), value: '2_plus_years' },
  ]

  const energySavingTechnologiesOptions = [
    { label: t('energySavingTechnologies.solar_panels'), value: 'solar_panels' },
    { label: t('energySavingTechnologies.heat_pumps'), value: 'heat_pumps' },
    { label: t('energySavingTechnologies.heat_recovery'), value: 'heat_recovery' },
    { label: t('energySavingTechnologies.quality_insulation'), value: 'quality_insulation' },
    { label: t('energySavingTechnologies.smart_home_system'), value: 'smart_home_system' },
    {
      label: t('energySavingTechnologies.led_lighting_motion_sensors'),
      value: 'led_lighting_motion_sensors',
    },
    { label: t('energySavingTechnologies.solar_collectors'), value: 'solar_collectors' },
    { label: t('energySavingTechnologies.geothermal_heating'), value: 'geothermal_heating' },
    { label: t('energySavingTechnologies.photovoltaic_systems'), value: 'photovoltaic_systems' },
  ]

  const energyConsumptionClassOptions = [
    { label: t('energyConsumptionClass.a_plus'), value: 'a_plus' },
    { label: t('energyConsumptionClass.a'), value: 'a' },
    { label: t('energyConsumptionClass.b'), value: 'b' },
    { label: t('energyConsumptionClass.c'), value: 'c' },
    { label: t('energyConsumptionClass.d'), value: 'd' },
    { label: t('energyConsumptionClass.e'), value: 'e' },
    { label: t('energyConsumptionClass.f'), value: 'f' },
    { label: t('energyConsumptionClass.g'), value: 'g' },
  ]

  const repairsAvaliabilityOptions = [
    { label: t('repairsAvailability.turnkey'), value: 'turnkey' },
    { label: t('repairsAvailability.needs_renovation'), value: 'needs_renovation' },
    { label: t('repairsAvailability.shell_condition'), value: 'shell_condition' },
  ]

  const yardOptions = [
    { label: t('yard.gated'), value: 'gated' },
    { label: t('yard.guarded'), value: 'guarded' },
    { label: t('yard.fenced'), value: 'fenced' },
    { label: t('yard.cctv'), value: 'cctv' },
    { label: t('yard.checkpoint_barrier'), value: 'checkpoint_barrier' },
    { label: t('yard.intercom_access'), value: 'intercom_access' },
    { label: t('yard.security_24_7'), value: 'security_24_7' },
    { label: t('yard.open_access'), value: 'open_access' },
    { label: t('yard.other'), value: 'other' },
  ]

  const objectStatusOptions = [
    { label: t('objectStatus.privatized'), value: 'privatized' },
    { label: t('objectStatus.mortgaged'), value: 'mortgaged' },
    { label: t('objectStatus.inherited'), value: 'inherited' },
    { label: t('objectStatus.municipal_property'), value: 'municipal_property' },
    { label: t('objectStatus.leased'), value: 'leased' },
    { label: t('objectStatus.joint_ownership'), value: 'joint_ownership' },
    { label: t('objectStatus.no_documents'), value: 'no_documents' },
    { label: t('objectStatus.processing_documents'), value: 'processing_documents' },
    { label: t('objectStatus.shared_construction'), value: 'shared_construction' },
    { label: t('objectStatus.other'), value: 'other' },
  ]

  const documentsOptions = [
    { label: t('documents.ready_for_sale'), value: 'ready_for_sale' },
    { label: t('documents.needs_finalization'), value: 'needs_finalization' },
  ]

  const securityOptions = [
    { label: t('security.video_surveillance'), value: 'video_surveillance' },
    { label: t('security.intercom_access_system'), value: 'intercom_access_system' },
    { label: t('security.concierge_guard'), value: 'concierge_guard' },
    { label: t('security.gated_area'), value: 'gated_area' },
  ]

  const heatingOptions = [
    { label: t('heating.central'), value: 'central' },
    { label: t('heating.autonomous'), value: 'autonomous' },
    { label: t('heating.gas'), value: 'gas' },
    { label: t('heating.electric'), value: 'electric' },
    { label: t('heating.solid_fuel'), value: 'solid_fuel' },
    { label: t('heating.geothermal'), value: 'geothermal' },
    { label: t('heating.infrared'), value: 'infrared' },
    { label: t('heating.stove'), value: 'stove' },
    { label: t('heating.fireplace'), value: 'fireplace' },
    { label: t('heating.solar'), value: 'solar' },
    { label: t('heating.mixed'), value: 'mixed' },
    { label: t('heating.no_heating'), value: 'no_heating' },
    { label: t('heating.other'), value: 'other' },
  ]

  const waterSupplyOptions = [
    { label: t('waterSupply.central'), value: 'central' },
    { label: t('waterSupply.well'), value: 'well' },
    { label: t('waterSupply.artesian_well'), value: 'artesian_well' },
    { label: t('waterSupply.autonomous'), value: 'autonomous' },
    { label: t('waterSupply.tank'), value: 'tank' },
    { label: t('waterSupply.spring_water'), value: 'spring_water' },
    { label: t('waterSupply.water_well'), value: 'water_well' },
    { label: t('waterSupply.mixed'), value: 'mixed' },
    { label: t('waterSupply.no_water'), value: 'no_water' },
    { label: t('waterSupply.other'), value: 'other' },
  ]
  const sewerageOptions = [
    { label: t('sewerage.central'), value: 'central' },
    { label: t('sewerage.septic'), value: 'septic' },
    { label: t('sewerage.autonomous_system'), value: 'autonomous_system' },
    { label: t('sewerage.no_sewerage'), value: 'no_sewerage' },
    { label: t('sewerage.other'), value: 'other' },
  ]
  const floorTypeOptions = [
    { label: t('floorType.parquet'), value: 'parquet' },
    { label: t('floorType.laminate'), value: 'laminate' },
    { label: t('floorType.tile'), value: 'tile' },
    { label: t('floorType.concrete'), value: 'concrete' },
    { label: t('floorType.linoleum'), value: 'linoleum' },
    { label: t('floorType.carpet'), value: 'carpet' },
    { label: t('floorType.wood_flooring'), value: 'wood_flooring' },
    { label: t('floorType.marble'), value: 'marble' },
    { label: t('floorType.ceramic_tile'), value: 'ceramic_tile' },
    { label: t('floorType.other'), value: 'other' },
  ]

  const windowTypeOptions = [
    { label: t('windowType.plastic'), value: 'plastic' },
    { label: t('windowType.wooden'), value: 'wooden' },
    { label: t('windowType.aluminum'), value: 'aluminum' },
    { label: t('windowType.combined'), value: 'combined' },
    { label: t('windowType.other'), value: 'other' },
  ]
  const luxuryRealEstateOptions = [
    { label: t('luxuryRealEstate.pool'), value: 'pool' },
    { label: t('luxuryRealEstate.gym'), value: 'gym' },
    { label: t('luxuryRealEstate.spa'), value: 'spa' },
    { label: t('luxuryRealEstate.private_garden'), value: 'private_garden' },
    { label: t('luxuryRealEstate.private_dock'), value: 'private_dock' },
    { label: t('luxuryRealEstate.exclusive_service'), value: 'exclusive_service' },
    { label: t('luxuryRealEstate.private_entrance'), value: 'private_entrance' },
    { label: t('luxuryRealEstate.walk_in_closet'), value: 'walk_in_closet' },
    { label: t('luxuryRealEstate.smart_home'), value: 'smart_home' },
    { label: t('luxuryRealEstate.climate_control'), value: 'climate_control' },
    { label: t('luxuryRealEstate.private_elevator'), value: 'private_elevator' },
  ]
  const commercialRenovationOptions = [
    { label: t('commercialRenovation.ready_for_use'), value: 'ready_for_use' },
    { label: t('commercialRenovation.needs_renovation'), value: 'needs_renovation' },
  ]

  // Commercial subtype (підтип комерції) — drives which extra fields make
  // sense and doubles as a first-class search filter.
  const commercialPurposeOptions = [
    { label: t('commercialPurpose.office'), value: 'office' },
    { label: t('commercialPurpose.shop'), value: 'shop' },
    { label: t('commercialPurpose.warehouse'), value: 'warehouse' },
    { label: t('commercialPurpose.production'), value: 'production' },
    { label: t('commercialPurpose.cafe_restaurant'), value: 'cafe_restaurant' },
    { label: t('commercialPurpose.hotel'), value: 'hotel' },
    { label: t('commercialPurpose.studio'), value: 'studio' },
    { label: t('commercialPurpose.maf'), value: 'maf' },
    { label: t('commercialPurpose.free_purpose'), value: 'free_purpose' },
    { label: t('commercialPurpose.other'), value: 'other' },
  ]

  const officeClassOptions = [
    { label: t('officeClass.a'), value: 'a' },
    { label: t('officeClass.b'), value: 'b' },
    { label: t('officeClass.c'), value: 'c' },
    { label: t('officeClass.d'), value: 'd' },
  ]

  // Land purpose (цільове призначення) — shared by the wizard and the edit
  // prefill, which wraps stored raw values back into these options.
  const landPurposeOptions = [
    { label: t('step3.landPurpose_residential'), value: 'residential' },
    { label: t('step3.landPurpose_personal_farming'), value: 'personal_farming' },
    { label: t('step3.landPurpose_gardening'), value: 'gardening' },
    { label: t('step3.landPurpose_commercial'), value: 'commercial' },
    { label: t('step3.landPurpose_industrial'), value: 'industrial' },
    { label: t('step3.landPurpose_recreational'), value: 'recreational' },
  ]

  const transportationAccessOptions = [
    { label: t('transportationAccess.freight_elevator'), value: 'freight_elevator' },
    { label: t('transportationAccess.ramp'), value: 'ramp' },
    { label: t('transportationAccess.client_parking'), value: 'client_parking' },
  ]

  const districtTypeOptions = [
    { label: t('districtType.central'), value: 'central' },
    { label: t('districtType.residential'), value: 'residential' },
    { label: t('districtType.industrial'), value: 'industrial' },
    { label: t('districtType.elite'), value: 'elite' },
    { label: t('districtType.commercial'), value: 'commercial' },
    { label: t('districtType.historic_center'), value: 'historic_center' },
    { label: t('districtType.green_zone'), value: 'green_zone' },
    { label: t('districtType.suburban'), value: 'suburban' },
    { label: t('districtType.resort'), value: 'resort' },
    { label: t('districtType.recreational'), value: 'recreational' },
    { label: t('districtType.waterfront'), value: 'waterfront' },
    { label: t('districtType.transport_hub'), value: 'transport_hub' },
    { label: t('districtType.rural'), value: 'rural' },
    { label: t('districtType.mixed_use'), value: 'mixed_use' },
    { label: t('districtType.other'), value: 'other' },
  ]

  const naturalAreasOptions = [
    { label: t('naturalAreas.river'), value: 'river' },
    { label: t('naturalAreas.lake'), value: 'lake' },
    { label: t('naturalAreas.sea'), value: 'sea' },
    { label: t('naturalAreas.forest'), value: 'forest' },
    { label: t('naturalAreas.park'), value: 'park' },
    { label: t('naturalAreas.nature_reserve'), value: 'nature_reserve' },
  ]

  const areaPrestigeLevelOptions = [
    { label: t('areaPrestigeLevel.economy'), value: 'economy' },
    { label: t('areaPrestigeLevel.standard'), value: 'standard' },
    { label: t('areaPrestigeLevel.comfort'), value: 'comfort' },
    { label: t('areaPrestigeLevel.business'), value: 'business' },
    { label: t('areaPrestigeLevel.premium'), value: 'premium' },
  ]

  const roadConditionOptions = [
    { label: t('roadCondition.paved'), value: 'paved' },
    { label: t('roadCondition.dirt'), value: 'dirt' },
    { label: t('roadCondition.poor_condition'), value: 'poor_condition' },
    { label: t('roadCondition.cobblestone'), value: 'cobblestone' },
    { label: t('roadCondition.no_surface'), value: 'no_surface' },
    { label: t('roadCondition.temporary'), value: 'temporary' },
    { label: t('roadCondition.under_construction'), value: 'under_construction' },
  ]
  const naturalFactorsRiskOptions = [
    { label: t('naturalFactorsRisk.flood_zone'), value: 'flood_zone' },
    { label: t('naturalFactorsRisk.landslide_zone'), value: 'landslide_zone' },
    { label: t('naturalFactorsRisk.forest_fires'), value: 'forest_fires' },
    { label: t('naturalFactorsRisk.flight_paths'), value: 'flight_paths' },
    { label: t('naturalFactorsRisk.radiation_zone'), value: 'radiation_zone' },
    { label: t('naturalFactorsRisk.mineral_sources'), value: 'mineral_sources' },
    { label: t('naturalFactorsRisk.groundwater_flood'), value: 'groundwater_flood' },
  ]
  const securityLevelOptions = [
    { label: t('securityLevel.very_safe'), value: 'very_safe' },
    { label: t('securityLevel.safe'), value: 'safe' },
    { label: t('securityLevel.moderate'), value: 'moderate' },
    { label: t('securityLevel.unsafe'), value: 'unsafe' },
    { label: t('securityLevel.very_unsafe'), value: 'very_unsafe' },
    { label: t('securityLevel.unknown'), value: 'unknown' },
  ]
  const windowOrientationOptions = [
    { label: t('windowOrientation.east'), value: 'east' },
    { label: t('windowOrientation.west'), value: 'west' },
    { label: t('windowOrientation.south'), value: 'south' },
    { label: t('windowOrientation.north'), value: 'north' },
  ]

  const planningTypeOptions = [
    { label: t('planningType.studio'), value: 'studio' },
    { label: t('planningType.separate_rooms'), value: 'separate_rooms' },
  ]

  const remoteWorkOptions = [
    { label: t('remoteWork.fiber_internet'), value: 'fiber_internet' },
    { label: t('remoteWork.5g_signal'), value: '5g_signal' },
    { label: t('remoteWork.workspace_friendly'), value: 'workspace_friendly' },
  ]

  const outbuildingsOptions = [
    { label: t('outbuildings.garage'), value: 'garage' },
    { label: t('outbuildings.basement'), value: 'basement' },
    { label: t('outbuildings.shed'), value: 'shed' },
    { label: t('outbuildings.greenhouse'), value: 'greenhouse' },
  ]

  return {
    currencyOptions,
    cellingHeightOptions,
    yearOfConstructionOptions,
    furnitureOptions,
    parkingOptions,
    amenitiesOptions,
    transportOptions,
    infrastructureOptions,
    windowViewOptions,
    utilitiesOptions,
    minRentTermOptions,
    energySavingTechnologiesOptions,
    energyConsumptionClassOptions,
    repairsAvaliabilityOptions,
    yardOptions,
    objectStatusOptions,
    documentsOptions,
    securityOptions,
    heatingOptions,
    waterSupplyOptions,
    sewerageOptions,
    floorTypeOptions,
    windowTypeOptions,
    luxuryRealEstateOptions,
    commercialRenovationOptions,
    commercialPurposeOptions,
    officeClassOptions,
    landPurposeOptions,
    transportationAccessOptions,
    districtTypeOptions,
    naturalAreasOptions,
    areaPrestigeLevelOptions,
    roadConditionOptions,
    naturalFactorsRiskOptions,
    securityLevelOptions,
    windowOrientationOptions,
    planningTypeOptions,
    remoteWorkOptions,
    outbuildingsOptions,
  }
}
